// src/dq/StatusGuide.tsx - "How statuses are decided": the gates behind Pre-approved / Needs a decision / Set aside,
// from the server (status_guide.py - the same text as the rulebook export's "How to read" sheet).
import React, { useEffect, useState } from "react";
import { apiGet } from "../API";

interface GuideSection { title: string; rows: [string, string][] }

export default function StatusGuide({ entityId, onClose }: { entityId: string; onClose: () => void; key?: any }) {
  const [secs, setSecs] = useState<GuideSection[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    apiGet(`/adriva_api/dq/sdh/${encodeURIComponent(entityId)}/status-guide`)
      .then((r: any) => setSecs((r?.result ?? r) as GuideSection[]))
      .catch((e: any) => setErr(String(e?.message || e)));
  }, [entityId]);
  return (
    <div className="sg-scrim" onClick={onClose}>
      <style>{CSS}</style>
      <div className="sg-panel" onClick={(e: any) => e.stopPropagation()}>
        <div className="sg-head">
          <div><div className="sg-title">How statuses are decided</div>
            <div className="sg-sub">The same gates apply to every rule and every discovery run. Nothing is enforced until you approve it.</div></div>
          <button className="sg-x" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="sg-body">
          {err && <div className="sg-err">{err}</div>}
          {!secs && !err && <div className="sg-d">Loading…</div>}
          {(secs || []).map((s) => (
            <div key={s.title} className="sg-sec">
              <div className="sg-st">{s.title}</div>
              <table><tbody>{s.rows.map(([a, b]) => <tr key={a}><td className="sg-a">{a}</td><td>{b}</td></tr>)}</tbody></table>
            </div>))}
        </div>
      </div>
    </div>
  );
}

const CSS = `
.sg-scrim{position:fixed;inset:0;z-index:2600;background:rgba(14,36,54,.42);display:flex;justify-content:flex-end}
.sg-panel{width:min(820px,96vw);height:100%;background:#fff;display:flex;flex-direction:column;box-shadow:-8px 0 30px rgba(0,0,0,.18)}
.sg-head{display:flex;align-items:flex-start;gap:12px;padding:18px 22px 10px;border-bottom:1px solid #e5e8eb}
.sg-title{font-size:18px;font-weight:700;color:#1d2a35}.sg-sub{font-size:12.5px;color:#5b6b78;margin-top:3px}
.sg-x{margin-left:auto;all:unset;cursor:pointer;font-size:24px;color:#5b6b78;padding:0 6px}
.sg-body{flex:1;overflow:auto;padding:12px 22px}
.sg-sec{margin-bottom:16px}.sg-st{font-size:13.5px;font-weight:700;color:#460073;margin-bottom:6px}
.sg-sec table{border-collapse:collapse;width:100%;font-size:12.5px}
.sg-sec td{border-bottom:1px solid #eef0f2;padding:6px 8px;vertical-align:top;color:#33424f}
.sg-a{width:230px;font-weight:600;color:#1d2a35}
.sg-d{color:#5b6b78;font-size:12.5px}.sg-err{background:#fef2f2;color:#991b1b;border-radius:7px;padding:6px 9px;font-size:12px}
`;
